import { html, LitElement } from 'lit';

class TwitterIcon extends LitElement {
  render() {
    return html`<svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44 8.4234C42.3819 9.15838 40.6437 9.65499 38.8164 9.87946C40.7018 8.72294 42.1125 6.90272 42.785 4.75843C41.0135 5.83704 39.0748 6.59627 37.0529 7.0031C35.6933 5.51499 33.8925 4.52865 31.93 4.19721C29.9675 3.86577 27.9532 4.20777 26.1997 5.17012C24.4463 6.13247 23.0518 7.66133 22.2328 9.51933C21.4139 11.3773 21.2162 13.4605 21.6706 15.4455C18.0811 15.2607 14.5697 14.3043 11.3642 12.6384C8.15862 10.9725 5.33062 8.63429 3.06368 5.77548C2.28856 7.14613 1.84286 8.73527 1.84286 10.4277C1.842 11.9513 2.20801 13.4516 2.90842 14.7954C3.60884 16.1392 4.622 17.285 5.85801 18.1311C4.42456 18.0844 3.02274 17.6873 1.76922 16.973V17.0922C1.76908 19.2291 2.49015 21.3002 3.8101 22.9542C5.13004 24.6081 6.96755 25.743 9.01083 26.1662C7.68107 26.5352 6.28692 26.5895 4.93367 26.3252C5.51017 28.1638 6.63313 29.7717 8.14534 30.9236C9.65756 32.0755 11.4833 32.7139 13.367 32.7493C10.1693 35.3225 6.22016 36.7184 2.15485 36.7122C1.43472 36.7124 0.715201 36.6693 0 36.5831C4.12653 39.3029 8.93011 40.7463 13.836 40.7407C30.4431 40.7407 39.5217 26.641 39.5217 14.4125C39.5217 14.0152 39.512 13.614 39.4946 13.2167C41.2605 11.9076 42.7848 10.2865 43.9961 8.42936L44 8.4234V8.4234Z"
        fill="#494949"
      />
    </svg>`;
  }
}

customElements.define('twitter-icon', TwitterIcon);
